export default __webpack_public_path__ + "static/media/ITINERARY_10.2b3a8dfc.png";